import { Component, inject } from '@angular/core';
import { AIChatbotService } from '../../services/ai-chatbot/ai-chatbot.service';

@Component({
  selector: 'ai-chatbot-branding-toggle',
  templateUrl: './ai-chatbot-branding-toggle.component.html',
  styleUrl: './ai-chatbot-branding-toggle.component.scss',
  standalone: false,
})
export class AiChatbotBrandingToggleComponent {
  protected aiChatbotService = inject(AIChatbotService);

  protected onToggle(): void {
    this.aiChatbotService.showBranding.update((value) => !value);
  }
}
